import React from 'react';
import TopBar from './TopBar.js';
import PWAInstallPrompt from './PWAInstallPrompt.js';

function HomePage() {
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    window.location.href = '/login';
  };

  return (
    <>
        <TopBar />
        <PWAInstallPrompt />
        <div style={{ padding: '16px', marginTop: '60px' }}>
        <h1>Welcome to the Home Page</h1>
        <button onClick={handleLogout}>Logout</button>
        </div>
    </>
  );
}

export default HomePage;